var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'accessibility-mode': _vm.isAccessibilityMode},attrs:{"id":"app"}},[_c('div',{staticClass:"wrapper"},[_c('Header',{on:{"toggleAccessibility":_vm.toggleAccessibilityMode}}),_c('div',{staticClass:"main"},[_c('router-view'),_c('WidgetComponent')],1),_c('Footer')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }